export default __webpack_public_path__ + "static/media/office-3.a6e0375d.webp";